import { Questionnaires } from "@/fhir/enums/questionnaires";

export const questionnaireURLBasedOnEncounterType = {
  Prenatal: Questionnaires.Prenatal,
  Postpartum: Questionnaires.PostpartumEncounter,
  Gynecological: Questionnaires.GynecologicalEncounter,
  "Newborn IPP": Questionnaires.NewbornIPPEncounter,
  "Newborn Postpartum": Questionnaires.NewbornPostpartumEncounter,
  "Labor and Delivery": Questionnaires.LaborAndDelivery,
  "Early Care": Questionnaires.EarlyCare,
  "Primary Care": Questionnaires.PrimaryCare,
  "Transfer of Care": Questionnaires.TransferOfCare,
};

export type QuestionnaireURLBasedOnEncounterType =
  keyof typeof questionnaireURLBasedOnEncounterType;
